import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Modal, Alert } from 'react-bootstrap';
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';
import { QRCode } from 'react-qrcode-logo';
import Connection from '../../Calls';
import Backend from '../../Backend';

import Check from '../../Images/check.svg';
import CheckCorrect from '../../Images/check-correct.svg';
import GAuth from '../../Images/gauth.png'

export default class Deactivate2FA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step:0,
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
      showLoad: false,
    }
  }

  deactivateModal(){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    var code = this.state.digit1 + this.state.digit2 + this.state.digit3 + this.state.digit4 + this.state.digit5 + this.state.digit6
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      Backend.Disable2FA(localStorage.getItem('email'), localStorage.getItem('token'), code, payload.r01, response=>{
        if (response.status.code === "0") {
          self.setState({
            digit1: '',
            digit2: '',
            digit3: '',
            digit4: '',
            digit5: '',
            digit6: '',
          });
          store.addNotification({
            title: "Success!",
            message: response.payload.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          self.props.refresh2FA();
          self.props.handleDeactivateModal(false);
        } else {
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          self.setState({
            digit1: '',
            digit2: '',
            digit3: '',
            digit4: '',
            digit5: '',
            digit6: '',
          });
          self.refs.digit_ref1.focus()
        }
      })
    })
  }
  handleShowQR(value) {
    this.setState({ showQR: value });
  }

  _handleChange(num,e) {
    const self = this;
    var target = e.target;
    var currentState = this.state
    currentState.err2FA = '';
    var myLength = target.value.length;
    if (myLength == 1) {
      currentState['digit' + num] = e.target.value
      this.setState(currentState,()=>{
        if(num != 6)self.refs['digit_ref' + (num+1)].focus();
        else self.deactivateModal()
      })
    } else if (myLength == 0){
      currentState['digit' + num] = e.target.value
      this.setState(currentState)
      if(num != 1)self.refs['digit_ref' + (num-1)].focus();
    }if (myLength > 1){
      currentState['digit' + (num+1)] = e.target.value[1]
      this.setState(currentState)
      if(num != 6)self.refs['digit_ref' + (num+1)].focus();
    }
  }

  handleKeyDown(e,n){
    const self = this;
    var target = e.target;
    var myLength = target.value.length;
    if(myLength < 1){
      if (e.keyCode === 8) {
        self.refs['digit_ref' + n].focus();
      }
    }
  }

  render(){
    return(
      <Modal className='change-pass-modal' show={this.props.deactivateModal} onHide={()=>this.props.handleDeactivateModal(false)}>
        <Modal.Body>
          <div className="border-title-separator-container-left" style={{ width: "100%" }}>
            <p className="title-container-shadow">{this.props.traductions.settings.services.modalTwoFa.titleD}</p>
          </div>
          <Alert variant='warning'>
            {this.props.traductions.settings.services.modalTwoFa.warning}
          </Alert>
          <div className='activate-2fa-titles'>
            <div className='gauth_logo inline-block'>
              <Image src={GAuth}/>
            </div>
            <div className='inline-block'>
              <p className='password-notice'>{this.props.traductions.General.TwoFa.desc}</p>
            </div>
          </div>
          <div style={{ marginTop: 25, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Container className="container-google-autenticathor">
              <Row>
                <Col md={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref1'
                    ref='digit_ref1'
                    maxlength='1'
                    value={this.state.digit1}
                    onChange={(digit1) => {this._handleChange(1,digit1)}}
                  />
                </Col>
                <Col md={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref2'
                    ref='digit_ref2'
                    maxlength='1'
                    value={this.state.digit2}
                    onChange={(digit2)=> {this._handleChange(2,digit2)}}
                    onKeyDown={(digit2) => {this.handleKeyDown(digit2,1)}}
                  />
                </Col>
                <Col md={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref3'
                    ref='digit_ref3'
                    maxlength='1'
                    value={this.state.digit3}
                    onChange={(digit3) => {this._handleChange(3,digit3)}}
                    onKeyDown={(digit3) => {this.handleKeyDown(digit3,2)}}
                  />
                </Col>
                <Col md={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref4'
                    ref='digit_ref4'
                    maxlength='1'
                    value={this.state.digit4}
                    onChange={(digit4) => {this._handleChange(4,digit4)}}
                    onKeyDown={(digit4) => {this.handleKeyDown(digit4,3)}}
                  />
                </Col>
                <Col md={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref5'
                    ref='digit_ref5'
                    maxlength='1'
                    value={this.state.digit5}
                    onChange={(digit5) => { this._handleChange(5,digit5)}}
                    onKeyDown={(digit5) => {this.handleKeyDown(digit5,4)}}
                  />
                </Col>
                <Col md={2}>
                  <input
                    className="form-control digits-google-autenticathor"
                    type="number"
                    name='digit_ref6'
                    ref='digit_ref6'
                    maxlength='1'
                    value={this.state.digit6}
                    onChange={(digit6) => { this._handleChange(6,digit6)}}
                    onKeyDown={(digit6) => {this.handleKeyDown(digit6,5)}}
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div style={{ marginTop: 30, textAlign: "center" }}>
            <Button className="label-signup-link" variant="link" onClick={() => this.props.handleDeactivateModal(false)}>{this.props.traductions.settings.services.modalTwoFa.btn_Cancel}</Button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
